import { HttpClient, } from "@angular/common/http";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { SSOTokenChecker } from "./app/shared/authentication";
var ɵ0 = function (http) {
    return new TranslateHttpLoader(http, "/assets/i18n/", ".json");
}, ɵ1 = function (tokenChecker) { return function () {
    return tokenChecker.loginViaCookie();
}; };
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
export { ɵ0, ɵ1 };
